import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import {
  sendReportsAction,
  setSelectedReportAction,
  setEmailsAction,
  clearErrorsAction,
  setReportSucessAction,
} from 'store/slices/reports/reportThunks';

export const useReports = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error, selectedReport, emails, reportsSuccess } = useSelector(state => state.reports);

  const handleEmailsChange = (emails) => {
    dispatch(setEmailsAction(emails));
  };

  const handleSetReportType = (reportType) => {
    dispatch(setSelectedReportAction(reportType));
  }

  const handleSendReports = () => {
    if (!selectedReport || emails.length === 0) return;
    dispatch(sendReportsAction(navigate, selectedReport, emails));      
  };

  const handleCloseReportSuccess = () => {
    dispatch(setReportSucessAction(false));
  };

  const handleCloseReportError = () => {
    dispatch(clearErrorsAction());
  };


  return {
    loading,
    error,
    selectedReport,
    emails,
    reportsSuccess,
    handleEmailsChange,
    handleSendReports,
    handleSetReportType,
    handleCloseReportSuccess,
    handleCloseReportError,
  };
}
